import React from 'react';
import classes from './CryptoPageLayer.module.css';

const HomeMainSection = () => {
  return <div className={`${classes.BgImg}`}></div>;
};

export default HomeMainSection;
